import React, { useState } from "react";
import { TbCaretUpDownFilled } from "react-icons/tb";
import { GrAttachment } from "react-icons/gr";
import Category_Select_Pop from "./Category_Select_Pop";
import  SelectPopup_Product_Details  from "./SelectPopup_Product_Details";
function Product_Details_form() {
  const [defaultUnit, setDefaultUnit] = useState("Kg");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal_Category, setShowModal_Category] = useState(false);

  const units = ["Kg", "Unit", "Litre", "Ton"];
  console.log(showModal);
  return (
    <div className="p-3 sm:p-5 border-2 border-gray-300 rounded-xl my-5">
      <p className="font-semibold text-gray-600 text-lg sm:text-xl underline">
        Product Details:
      </p>

      <div className="flex flex-col md:flex-row md:px-10 mt-4 gap-6 md:gap-10">
        {/* Left Column */}
        <div className="w-full md:w-1/2">
          {/* Product ID */}
          <div className="flex flex-col mt-4">
            <label
              htmlFor="productId"
              className="text-base sm:text-lg text-gray-600"
            >
              Product ID
            </label>
            <input
              type="text"
              id="productId"
              placeholder="Enter your Product ID"
              className="outline-none rounded-lg border border-gray-300 px-4 py-2 text-sm sm:text-base text-gray-600"
            />
          </div>

          {/* HSN Code */}
          <div className="flex flex-col mt-4 relative cursor-pointer">
            <label
              htmlFor="hsnCode"
              className="text-base sm:text-lg text-gray-600"
            >
              HSN Code of Product <span className="text-red-500">*</span>
            </label>
            <input
              onClick={() => setShowModal(true)}
              type="text"
              id="category"
              placeholder="Select HSN Code of Product"
              className="outline-none rounded-lg border cursor-pointer border-gray-300 px-4 py-2 pr-10 text-sm sm:text-base text-gray-600"
            />
            <TbCaretUpDownFilled
              className="absolute right-3 bottom-2.5 text-gray-500 pointer-events-none"
              size={20}
            />
          </div>

          {/* Default Unit of Measure */}
          <div className="flex flex-col mt-4">
            <label
              htmlFor="defaultUnitField"
              className="text-base sm:text-lg text-gray-600"
            >
              Default Unit of Measure
            </label>
            <div className="flex">
              <div className="relative w-full">
                <input
                  type="text"
                  id="defaultUnitField"
                  value={defaultUnit}
                  readOnly
                  className="w-full px-4 py-2 text-sm sm:text-base text-gray-600 rounded-l border border-gray-300 outline-none"
                />
                {isDropdownOpen && (
                  <div className="absolute left-0 top-full mt-1 w-full bg-white border border-gray-300 rounded shadow z-10">
                    {units.map((unit) => (
                      <div
                        key={unit}
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={() => {
                          setDefaultUnit(unit);
                          setIsDropdownOpen(false);
                        }}
                      >
                        {unit}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="bg-blue-500 text-white px-4 py-2 rounded-r hover:bg-blue-600 text-sm sm:text-base"
                type="button"
              >
                Change
              </button>
            </div>
          </div>

          {/* Product Images */}
          <div className="flex flex-col mt-4 relative">
            <label
              htmlFor="productImages"
              className="text-base sm:text-lg text-gray-600"
            >
              Product Images <span className="text-red-500">*</span>
            </label>
            <div className="relative w-full flex items-center">
              <label
                htmlFor="productImages"
                className="absolute top-1/2 transform -translate-y-1/2 bg-gray-200 text-gray-500 px-4 py-2 rounded cursor-pointer text-xs sm:text-sm z-1"
              >
                Choose File
              </label>
              <input
                type="file"
                id="productImages"
                className="hidden"
                multiple
              />
              <input
                type="text"
                placeholder="img.png, img.png, img.png"
                readOnly
                className="w-full text-gray-500 border border-gray-300 pl-32 pr-4 py-2 rounded outline-none text-sm sm:text-base"
              />
            </div>
          </div>

          {/* Present Stock Status */}
          <div className="flex flex-col mt-4 relative">
            <label
              htmlFor="presentStockStatus"
              className="text-base sm:text-lg text-gray-600 mb-1"
            >
              Present Stock Status
            </label>
            <div className="relative">
              <select
                id="presentStockStatus"
                className="appearance-none w-full outline-none rounded-lg border border-gray-300 px-4 py-2 text-sm sm:text-base text-gray-600 pr-10 bg-white"
                defaultValue=""
              >
                <option value="" disabled>
                  Select Present Stock Status
                </option>
                <option value="inStock">In Stock</option>
                <option value="outOfStock">Out of Stock</option>
              </select>
              <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                ▼
              </div>
            </div>
          </div>

          {/* Minimum Order Quantity */}
          <div className="flex flex-col mt-4">
            <label
              htmlFor="minOrderQty"
              className="text-base sm:text-lg text-gray-600"
            >
              Minimum Order Quantity
            </label>
            <div className="flex">
              <input
                type="text"
                id="minOrderQty"
                placeholder="Enter Minimum Order Quantity"
                className="w-full px-4 py-2 text-sm sm:text-base text-gray-600 rounded-l border border-gray-300 outline-none"
              />
              <button
                className="bg-gray-200 text-black px-6 py-2 rounded-r hover:bg-gray-300 text-sm sm:text-base"
                type="button"
              >
                kg
              </button>
            </div>
            <div className="flex justify-end mt-3">
              <button className="bg-gray-300 text-gray-700 px-5 py-1.5 rounded hover:bg-gray-400 text-sm sm:text-base">
                Add Fields
              </button>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="w-full md:w-1/2">
          {/* Product Name */}
          <div className="flex flex-col mt-4">
            <label
              htmlFor="productName"
              className="text-base sm:text-lg text-gray-600"
            >
              Product Name
            </label>
            <input
              type="text"
              id="productName"
              placeholder="Enter Product Name"
              className="outline-none rounded-lg border border-gray-300 px-4 py-2 text-sm sm:text-base text-gray-600"
            />
          </div>

          {/* Category */}
          <div className="flex flex-col mt-4 relative cursor-pointer">
            <label
              htmlFor="category"
              className="text-base sm:text-lg text-gray-600"
            >
              Category of Product <span className="text-red-500">*</span>
            </label>
            <input
              onClick={() => setShowModal_Category(true)}
              type="text"
              id="category"
              placeholder="Enter Category of Product"
              className="outline-none rounded-lg border cursor-pointer border-gray-300 px-4 py-2 pr-10 text-sm sm:text-base text-gray-600"
            />
            <TbCaretUpDownFilled
              className="absolute right-3 bottom-2.5 text-gray-500 pointer-events-none"
              size={20}
            />
          </div>

          {/* Price Range */}
          <div className="flex flex-col mt-4">
            <label
              htmlFor="indicativePriceRange"
              className="text-base sm:text-lg text-gray-600"
            >
              Indicative Price Range
            </label>
            <div className="flex items-center gap-2">
              <input
                type="text"
                id="minPrice"
                placeholder="Enter Minimum Price"
                className="outline-none rounded-lg border w-full border-gray-300 px-4 py-2 text-sm sm:text-base text-gray-600"
              />
              <span className="text-gray-600">-</span>
              <input
                type="text"
                id="maxPrice"
                placeholder="Enter Maximum Price"
                className="outline-none rounded-lg border w-full border-gray-300 px-4 py-2 text-sm sm:text-base text-gray-600"
              />
            </div>
          </div>

          {/* Production Capacity */}
          <div className="flex flex-col mt-4">
            <label
              htmlFor="productionCapacity"
              className="text-base sm:text-lg text-gray-600"
            >
              Production Capacity
            </label>
            <div className="flex">
              <input
                type="text"
                id="productionCapacity"
                placeholder="Enter Monthly Production Capacity Quantity"
                className="w-full px-4 py-2 text-sm sm:text-base text-gray-600 rounded-l border border-gray-300 outline-none"
              />
              <button
                className="bg-gray-200 text-black px-6 py-2 rounded-r hover:bg-gray-300 text-sm sm:text-base"
                type="button"
              >
                kg
              </button>
            </div>
          </div>

          {/* Production Lead Time */}
          <div className="flex flex-col mt-4">
            <label
              htmlFor="productionLeadTime"
              className="text-base sm:text-lg text-gray-600"
            >
              Production Leads Time in Days
            </label>
            <input
              type="text"
              id="productionLeadTime"
              placeholder="Enter No. of Production Leads Time in Days"
              className="outline-none rounded-lg border border-gray-300 px-4 py-2 text-sm sm:text-base text-gray-600"
            />
          </div>

          {/* Product Certificates */}
          <div className="flex flex-col mt-4">
            <label
              htmlFor="productCertificates"
              className="text-base sm:text-lg text-gray-600"
            >
              Attach Product Certificates
            </label>
            <div className="flex rounded-l border border-gray-300">
              <button
                className="bg-gray-200 text-black px-6 py-2 rounded-l hover:bg-gray-300 flex items-center gap-2 text-sm sm:text-base"
                type="button"
              >
                <GrAttachment />
                Attachments
              </button>
              <input
                type="text"
                id="productCertificates"
                placeholder="Enter Certificate File Name"
                className="w-full px-4 py-2 text-sm sm:text-base text-gray-600 outline-none"
              />
            </div>
            <div className="flex justify-end mt-3">
              <button className="bg-gray-300 text-gray-700 px-5 py-1.5 rounded hover:bg-gray-400 text-sm sm:text-base">
                Add Fields
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <SelectPopup_Product_Details
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        />
      )}

      {showModal_Category && (
        <Category_Select_Pop
          isOpen={showModal_Category}
          onClose={() => setShowModal_Category(false)}
        />
      )}
    </div>
  );
}

export default Product_Details_form;








